<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" sm="9">
        <v-card>
          <v-card-title>
            {{ mode === "CREATE" ? "Create" : "Edit" }} Company
          </v-card-title>
          <v-form ref="form">
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="company.name"
                    label="Name*"
                    :rules="[rules.required]"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="company.phone"
                    label="Phone*"
                    :rules="[rules.required]"
                  />
                </v-col>
                <v-col cols="12" md="12" class="py-0">
                  <h4>Address</h4>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="company.address.streetName"
                    label="Street Name*"
                    :rules="[rules.required]"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="company.address.streetName2"
                    label="Street Name (2)"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="company.address.city" label="City*" />
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="company.address.state"
                    v-mask="masks.stateAbbrv"
                    label="State*"
                    :rules="[rules.required]"
                    data-cy="company-text-personal-state"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="company.address.zipCode"
                    label="Zip Code*"
                  />
                </v-col>
                <v-col cols="12">
                  <v-select
                        v-model="company.taxClassification"
                        :items="[
                          'Sole Proprietor',
                          'Corporation',
                          'Limited Liability Company',
                          'General Partnership'
                        ]"
                        label="Tax Classification"
                        :rules="[rules.required]"
                        data-cy="company-form-select-pay-day"
                      />
                </v-col>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12" sm="6">
                      <v-select
                        v-model="company.payDay"
                        :items="[
                          'Monday',
                          'Tuesday',
                          'Wednesday',
                          'Thursday',
                          'Friday',
                          'Saturday',
                          'Sunday',
                          'Custom'
                        ]"
                        label="Pay Day"
                        :rules="[rules.required]"
                        data-cy="company-form-select-pay-day"
                      />
                    </v-col>
                    <v-col v-if="company.payDay === 'Custom'" cols="12">
                      <v-text-field
                        v-model="company.customPayDay"
                        label="Pay Day (Custom)"
                        data-cy="company-form-text-price"
                      />
                    </v-col>
                    <v-col v-if="company.payDay !== 'Custom'" cols="12" sm="6">
                      <v-select
                        v-model="payDayFrequency"
                        :items="payDayFrequencyOptions"
                        label="Pay Day Frequency"
                        data-cy="company-form-select-pay-day-frequency"
                      />
                    </v-col>
                    <v-col v-if="payDayFrequency === 'Other' && company.payDay !== 'Custom'" cols="12">
                      <v-text-field
                        v-model="payDayFrequencyOther"
                        label="Pay Day Frequency"
                        data-cy="company-form-text-price"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-switch
                    v-model="company.activeSubscription"
                    label="Has Active Subscription"
                  />
                </v-col>
                <v-col>
                  <h3>Additional Start Paperwork (put pdfme data in here) </h3>
                  <v-textarea v-model="company.additionalFiles" />
                </v-col>
              </v-row>
              <v-row justify="end">
                <v-col cols="auto">
                  <v-btn text outlined :to="{ name: 'companies' }">
                    cancel
                  </v-btn>
                </v-col>
                <v-col cols="auto">
                  <v-btn color="primary" @click="submit"> Submit </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import rules from "../utils/rules";
import {
  companyCreate,
  getCompany,
  companyUpdate,
} from "../services/companies";
import masks from "../utils/masks";

export default {
  props: {
    mode: {
      type: String,
      default: "EDIT",
    },
  },
  data() {
    return {
      company: {
        name: "",
        phone: "",
        address: {},
        payDayFrequency: "",
        payDayFrequencyOther: "",
        taxClassification: "",
        activeSubscription: false,
      },
      rules,
      masks,

      payDayCustom: '',
      
      payDayFrequency: "",
      payDayFrequencyOther: "",

      payDayFrequencyOptions: ["Weekly", "Biweekly", "Other"],
      submitButtonIsLoading: false,
    };
  },
  async mounted() {
    if (this.mode === "EDIT") {
      const { data } = await getCompany(this.$route.params.companyId);
      this.company = data;
      this.payDayFrequency = data.payDayFrequency
      if (!this.payDayFrequencyOptions.includes(this.payDayFrequency)) {
        this.payDayFrequency = 'Other'
        this.payDayFrequencyOther = data.payDayFrequency
      }
    }
  },
  methods: {
    userText(val) {
      return `${val.firstName} ${val.lastName} (${val.email})`;
    },
    async submit() {
      if (!this.$refs.form.validate()) {
        this.scrollToFirstFormError();
        return;
      }
      this.submitButtonIsLoading = true;
      const company = JSON.parse(JSON.stringify(this.company));
      company.payDayFrequency =
          this.payDayFrequency === "Other"
            ? this.payDayFrequencyOther
            : this.payDayFrequency;
      try {
        if (this.mode === "CREATE") {
          await companyCreate(company);
        } else {
          await companyUpdate(company);
        }
        this.$router.push({ name: "companies" });
      } catch (e) {
        if (e.response.status === 502) {
          this.$emit("snackbar", { text: "502 Bad Gateway", color: "red" });
        } else {
          this.$emit("snackbar", {
            text: "Error Submitting Forms",
            color: "red",
          });
        }
      }
    },
    scrollToFirstFormError() {
      let firstInvalidInput;
      this.$refs.form.inputs.some((input) => {
        if (!input.valid) {
          firstInvalidInput = input;
        }
        return !input.valid;
      });
      if (firstInvalidInput) {
        this.$vuetify.goTo(firstInvalidInput.$el);
      }
    },
  },
};
</script>

<style>
</style>
